module.exports = __webpack_public_path__ + "static/media/dark_blue-t.93464a41.svg";